import Decimal from "decimal.js";

export const toDecimalAndFixed = (val, fixed = 8) => {
  if (!val) return 0;
  const num = new Decimal(String(val));
  return num.floor(fixed).toFixed();
};

export const toDesimalPlaces = (val, places) => {
  if (!val) return 0;
  const num = new Decimal(String(val));
  const ret = num.toFixed(places)
  return ret
}

export const decimalPlus = (val1, val2) => {
  const num1 = new Decimal(String(val1 || '0'));
  const num2 = new Decimal(String(val2 || '0'));
  return num1.plus(num2).toFixed();
}

export const decimalMinus = (val1, val2) => {
  const num1 = new Decimal(String(val1 || '0'));
  const num2 = new Decimal(String(val2 || '0'));
  return num1.minus(num2).toFixed();
}

export const decimalMultiply = (val1, val2) => {
  const num1 = new Decimal(String(val1 || '0'));
  const num2 = new Decimal(String(val2 || '0'));
  return num1.mul(num2).toFixed();
}

export const decimalDivide = (val1, val2) => {
  const num1 = new Decimal(String(val1 || '0'));
  const num2 = new Decimal(String(val2 || '0'));
  return num1.div(num2).toFixed();
}
